import drawerTemplate from './nav-drawer.template.html';

export function NavDrawerDirective($controller, $q: angular.IQService, $animate: angular.animate.IAnimateService, $compile, $document, $templateRequest): angular.IDirective {
    return {
        scope: {
            template: "<",
            templateUrl: "<",
            controller: "<",
            controllerAs: "<"
        },
        template: drawerTemplate,
        link: (scope: qp.ui.bootstrap.navdrawer.INavDrawerDirectiveScope, element, attributes, ctrls) => {
            let CONTAINER_URL = "drawerContainer.html";
            let BACKDROP_URL = "backdrop.html";
            if (!scope.controller) {
                throw new Error('controller options is required.');
            }
            if (!scope.template && !scope.templateUrl) {
                throw new Error('template or templateUrl options is required.');
            }
            function getTemplatePromise(setting: qp.ui.bootstrap.navdrawer.IDrawerTemplateSetting) {
                return setting.template ?
                        $q.when(setting.template) :
                        $templateRequest(angular.isFunction(setting.templateUrl) ? setting.templateUrl() : setting.templateUrl);
            }
            let ctrlAs = scope.controllerAs || '$ctrl';
            // 菜单容器DOM
            let containerDOMStr;
            // 传入的内容
            let contentDOMStr;
            // 遮罩
            let backdropDomEl;
            // 创建获取容器模板promise
            let containerPromise = getTemplatePromise({ templateUrl: CONTAINER_URL });
            let backdropPromise = getTemplatePromise({ templateUrl: BACKDROP_URL });

            scope.open = function () {
                let drawerScope = scope.$new();
                let contentPromise = getTemplatePromise({ template: scope.template, templateUrl: scope.templateUrl })
                $q.all([containerPromise, contentPromise, backdropPromise]).then(tplResp => {
                    // 容器模板
                    containerDOMStr = angular.element(tplResp[0]);
                    // 传入的导航内容模板
                    contentDOMStr = angular.element(tplResp[1]);
                    backdropDomEl = angular.element(tplResp[2]);

                    // 创建模板关联的controller
                    let ctrlInstantiate = $controller(scope.controller, { $scope: drawerScope }, true, ctrlAs);

                    let ctrlInstance = ctrlInstantiate();
                    if (angular.isFunction(ctrlInstance.$onInit)) {
                        ctrlInstance.$onInit();
                    }
                    $compile(backdropDomEl)(drawerScope);
                    // 添加背景层
                    $animate.enter(backdropDomEl, $document.find('body').eq(0));
                    // 设置菜单内容
                    angular.element(containerDOMStr).append(contentDOMStr);
                    // 添加菜单
                    $animate.enter($compile(containerDOMStr)(drawerScope), $document.find('body').eq(0));

                }, () => {
                    throw new Error("Get template fail");
                })
            }
            scope.close = function () {
                $animate.leave(containerDOMStr);
                $animate.leave(backdropDomEl);
            }

        }
    }
}

NavDrawerDirective.$inject = ["$controller", "$q", "$animate", "$compile", "$document", "$templateRequest"];